// extracted by mini-css-extract-plugin
export default {"tab-list":"GroceryCategoryTabList-module__tab-list__vAi3P","tab-list-item":"GroceryCategoryTabList-module__tab-list-item__uFssN"};